import { app } from '../../utils/store';

export default class Forms {
    constructor() {
        this.input = {
            file: document.querySelectorAll('input[type="file"]')
        };

        this.form = {
            cf7: document.querySelectorAll('.wpcf7-form'),
            newsletter: document.querySelector('form.newsletter-form'),
            streaming: document.querySelector('form.streaming-form'),
            file: document.querySelectorAll('form.file-form'),
            subscribe: document.querySelectorAll('form.subscribe-form'),
        }

        this.modal = {
            slides: document.getElementById('slides-modal'),
            streaming: document.getElementById('streaming-modal'),
            video: document.getElementById('video-modal'),
            file: document.querySelectorAll('[id*="file-modal-"]'),
        }

        this.fields = document.querySelector('form .fields');
        this.topics = document.getElementById('select-topics');

        this.header = document.querySelector('header');
        this.body = document.querySelector('body');
    }

    init() {
        this.validation();

        if(this.form.cf7[0]){
            this.manipulate();
        }

        // Newsletter Form
        if(this.form.newsletter){
            this.newsletter();
        }

        // Streaming Form
        if(this.form.streaming){
            this.streaming();
        }

        // File Download Form
        if(this.form.file){
            this.downloadFile();
        }

        // Open tank landin event
        if(this.form.subscribe){
            this.openLanding()
        }
    }

    validation = () => {
        this.input.file.forEach((input) => {
            input.addEventListener('change', () => {
                var file = input.value;
                if (!file) {
                    input.classList.remove('valid');
                } else {
                    input.classList.add('valid');
                }
            });
        });
    }

    cf7Events = () => {
        
    }

    newsletter = () => {
        this.fields.append(this.topics);
        this.fields.outerHTML = this.fields.innerHTML;

        var topics = [];

        document.querySelectorAll('#select-topics label[class*="check-"]').forEach((checkbox)=>{
            checkbox.addEventListener('click',(e)=>{
                // CLean the Array
                topics = [];

                // Set 'Selected'
                var input = e.target.querySelector('input');
                input.classList.toggle('selected');
                
                var selected = document.querySelectorAll('#select-topics input.selected');
                
                // For Each 'Selected' do the job!
                selected.forEach((selected)=>{
                    var topic = selected.getAttribute('data-topic');
                    // Compile the Array
                    topics.push(topic);

                    // ✅ Set the value to CF7 Hidden field 'topics'
                    document.querySelector('.wpcf7-form-control[name="topics"]').value = topics.join(", ");
                });
                
            });
        });
    }

    streaming = () => {
        console.log(this.modal.streaming)
        this.form.streaming.addEventListener( 'wpcf7mailsent', function( event ) {
            // Reset Variables
            var header = document.querySelector('header');
            var streaming = document.getElementById('streaming-modal');
            var video = document.getElementById('video-modal');

            // Do the switch of modals
            streaming.classList.remove('active');
            
            header.classList.add('modal-video');
            header.classList.add('modal-active');
            
            if(!video.getAttribute('data-youtube')){
                video.querySelector('video').play();
            }
            video.classList.add('active');

            // Change the toggler only AFTER you submit your form
            var toggler = document.querySelector('section.cta-event .streaming button.btn-modal');

            toggler.setAttribute('data-target',video.id);
            toggler.classList.add('btn-video');

            // Set a cookie of that file
            if(event.detail.status !== "validation_failed"){
                var cookiename = 'streaming-' + video.getAttribute('data-post');
                var postID = video.getAttribute('data-post');

                console.log(cookiename)
                setCookie(cookiename,postID);
            }

            function getCookie(cname) {
                var name = cname + "=";
                var decodedCookie = decodeURIComponent(document.cookie);
                var ca = decodedCookie.split(';');
                for(var i = 0; i <ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) == ' ') {
                        c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                        return c.substring(name.length, c.length);
                    }
                }
                return "";
            }
    
            function setCookie(cname, cvalue) {
                var d = new Date();
                d.setTime(d.getTime() + (10*365*24*60*60*1000));
                var expires = "expires="+ d.toUTCString();
                document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
            }

        }, false );
    }


    downloadFile = () => {
        this.form.file.forEach((form)=>{
            form.addEventListener( 'wpcf7mailsent', function( event ) {
                // Reset Variables
                var header = document.querySelector('header');
                var file = form.parentNode.parentNode.parentNode.parentNode.parentNode;
                var url = file.getAttribute('data-file');
                
                var toggler = document.querySelector('section.visual a.btn-file,section.two-column-text a.btn-file ');
                
                // Do the switch of modals
                file.classList.remove('active');
    
                // Open the file in new tab
                if(Sniff.browser.name == 'safari'){
                    var button = toggler.querySelector('.btn-file span');
                    button.innerHTML = button.getAttribute('data-label');
                    button.classList.add('click-me');
                    document.querySelector('section.visual').scrollIntoView();
                } else {
                    setTimeout(()=>{
                        window.open(url, '_blank');
                    },1500);
                }
                
                // Change the toggler only AFTER you submit your form
    
                header.classList.remove('modal-active');
                document.getElementById('menu-toggler').classList.remove('active');
                document.querySelector('body').classList.remove('overflow-hidden');
                toggler.setAttribute('href', url);
                toggler.removeAttribute('data-target');
                toggler.classList.remove('btn-modal');

    
                // Set a cookie of that video
                if(event.detail.status !== "validation_failed"){
                    var postID = file.getAttribute('data-post');
                    var cookiename = 'file-' + postID;
    
                    console.log(cookiename)
                    setCookie(cookiename,postID);
                }
    
                function getCookie(cname) {
                    var name = cname + "=";
                    var decodedCookie = decodeURIComponent(document.cookie);
                    var ca = decodedCookie.split(';');
                    for(var i = 0; i <ca.length; i++) {
                        var c = ca[i];
                        while (c.charAt(0) == ' ') {
                            c = c.substring(1);
                        }
                        if (c.indexOf(name) == 0) {
                            return c.substring(name.length, c.length);
                        }
                    }
                    return "";
                }
        
                function setCookie(cname, cvalue) {
                    var d = new Date();
                    d.setTime(d.getTime() + (10*365*24*60*60*1000));
                    var expires = "expires="+ d.toUTCString();
                    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
                }
    
            }, false );
        })
    }

    openLanding = () => {
        this.form.subscribe.forEach((form)=>{
            form.addEventListener( 'wpcf7mailsent', function( event ) {
                // Reset Variables
                var file = form.querySelector('input[name="landing"]');
                var url = file.value;

                setTimeout(()=>{
                    window.location.replace(url);
                },500);
                
                // var toggler = document.querySelector('section.visual a.btn-file,section.two-column-text a.btn-file ');
                
                // Do the switch of modals
                // file.classList.remove('active');
    
                // Open the file in new tab
                // if(Sniff.browser.name == 'safari'){
                //     var button = toggler.querySelector('.btn-file span');
                //     button.innerHTML = button.getAttribute('data-label');
                //     button.classList.add('click-me');
                //     document.querySelector('section.visual').scrollIntoView();
                // } else {
                //     setTimeout(()=>{
                //         window.open(url);
                //     },1500);
                // }
    
            }, false );
        })

    }

    manipulate = () => {
        // Moving the label inside the control <span class="wpcf7-form-control-wrap">
        this.form.cf7.forEach((form)=>{
            form.querySelectorAll('.input-container label').forEach((label)=>{
                label.parentNode.querySelector('.wpcf7-form-control-wrap').append(label);
            });
        });
    }
}